import jsonp from './jsonp';

/**
 * 获取视频评论数
 * @param {String} guid
 */
const getVideoCommentsCounts = async commentUrl => {
    const commentDomain =  typeof window === 'object' && window.allData?.__cd__ ? window.allData.__cd__: 'c01049em.ifeng.com';

    return await jsonp(`//${commentDomain}/getv.php`, {
        data: {
            job: 3,
            format: 'js',
            docurl: commentUrl,
        },
        cache: false,
    });
};

const getVideoCommentsCounts_v2 = async commentUrl => {
    const commentDomain =  typeof window === 'object' && window.allData?.__cd__ ? window.allData.__cd__: 'c01049em.ifeng.com';

    return await jsonp(`//${commentDomain}/get/comments`, {
        data: {
            p: 1,
            pageSize: 1,
            doc_url: commentUrl,
            format: 'js',
        },
        jsonpCallback: 'getVideoCNums',
        cache: false,
    });
};

/**
 * 获取视频点赞数量
 * @param {String} guid 视频id
 */
const getVideoZanCounts = async guid => {
    let num = 0;
    let callbackName = `getVideoZan_${num}`;

    while (window[callbackName]) {
        num++;
        callbackName = `getVideoZan_${num}`;
    }

    return await jsonp('//survey.news.ifeng.com/api/getaccumulatorweight', {
        data: {
            key: `${guid}ding`,
            format: 'js',
            serviceid: 1,
        },
        jsonpCallback: callbackName,
        cache: false,
    });
};

/**
 * 点赞视频
 * @param {String} guid
 */
const videoDianZan = async guid => {
    let num = 0;
    let callbackName = `dingVideo_${num}`;

    while (window[callbackName]) {
        num++;
        callbackName = `dingVideo_${num}`;
    }

    return await jsonp('//survey.news.ifeng.com/api/accumulator', {
        data: {
            key: `${guid}ding`,
            format: 'js',
        },
        jsonpCallback: callbackName,
    });
};

export { getVideoCommentsCounts, getVideoZanCounts, videoDianZan, getVideoCommentsCounts_v2 };
